'use strict';

var ConfigurationFlightTagDirective = function ConfigurationFlightTagDirective() {
  return {
    restrict: 'E',
    template: require('../templates/configuration-flight-tag.html'),
    controller: 'ConfigurationFlightTagController',
    link: function link() {}
  };
};
ConfigurationFlightTagDirective.$inject = [];
module.exports = ConfigurationFlightTagDirective;